export default {
  title:
    " Authing身份云-SSO单点登录系统-MFA多因素认证-统一身份认证平台-中国版OKTA-零信任-IDaaS-以开发者为中心",
  banner: {
    item1: {
      title: "",
      title2: "The identity cloud",
      subtitle:
        "Authing quickly implements authentication and user management for any Web, App, and enterprise software to provide the most complete login solution for your customers and employees.",
      subtitleSmall:
        "Authing quickly implements authentication and user management for any Web, App, and enterprise software to provide the most complete login solution for your customers and employees.",
    },
    item2: {
      title: "Authing named a",
      title2: "Sample Vendor in Gartner",
      subtitle:
        "Authing was named to Gartner《Hype Cycle for Security in China, 2022》, awarded as the Sample Vendor in BYOI.",
      // subtitleSmall:
      //   "使用 Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理",
    },
    item3: {
      title: "Authing x CSDN",
      title2: "IDaaS Community",
      subtitle:
        "Authing is proud to work with CSDN, the leading IT community in China, to promote the popularity of IDaaS in the developer community.",
      // subtitleSmall:
      //   "使用 Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理",
    },
    item4: {
      title: "Authing",
      title2: "2022 Annual Review",
      subtitle:
        "In 2022, we help customers improve their average ROI by 548%. In 2023, we will continue to deliver results that exceed expectations!",
      // subtitleSmall:
      //   "使用 Authing 快速实现任何 Web、App 和企业软件的身份认证和用户管理",
    },
  },
  guard: {
    title: "Authing starts with Login",
    subtitle: "Simply put, we make your login secure, stable and powerful",
    tooltip: "Register Authing, explore more!",
    "guard-ui": {
      title: "Customize Login",
      doc: "View doc",
      left: {
        baseSetting: "Regular login",
        password: "Forgot password",
        socialAccount: "Social account login",
        companyAccount: "Enterprise account login",
        funcSetting: "Function Configuration",
        loginProtal: "Identity Protoco",
        add: "Add",
        loginAdd: "Complete information",
        loginAddSub:
          "Using function to collect information when user login/register.",
        loginInfo: "Log in",
        resignInfo: "Sign in",
      },
      center: {
        title: "Login please",
        passLogin: "Password",
        rcode: "Email Code",
        account: "Enter Email",
        password: " Enter Password",
        login: "Log In",
        forgetPass: "Forgot password",
        regist: "Sign up now",
        thirdLogin: "Third-party account login",
        lang: "English",
      },
      right: {
        code: "No code",
        css: "With code",
        backgorund: "Custom background",
        color: "Solid color",
        picture: "Picture",
        icon: "Custom Icon",
        upload: "Upload Icon",
        language: "Language Setup",
        switch: "Switch Language",
        default: "Language",
        system: "System",
      },
      brand: "Brand",
      tech: "Tech",
      manual: "Manufacture",
      finance: "Finance",
    },
  },
  order1: {
    title: "Start with a free trail",
    subtitle: "Try Authing’s advanced features in 30 days.",
    titleSmall: "Start with a free trail",
    subtitleSmall: "Try Authing’s advanced features in 30 days.",
  },
  order2: {
    title: "Solution for Manufacturing",
    subtitle:
      "Enhance identity management and security systems to support the steady growth of enterprises.",
    titleSmall: "IDaaS replace IAM",
    subtitleSmall:
      "Meet the localized and upgraded IAM needs of enterprises in China.",
  },
  order3: {
    title: "Solution for Finance",
    subtitle:
      "Enhance enterprise management efficiency and financial services experience while ensuring data security.",
    titleSmall: "Solution for Finance",
    subtitleSmall:
      "Enhance enterprise management efficiency and financial services experience while ensuring data security.",
  },
  order4: {
    title: "Solution for Technology Industry",
    subtitle:
      "One time authentication, multi-point interconnection and one software global monitoring.",
    titleSmall: "Solution for Technology Industry",
    subtitleSmall:
      "One time authentication, multi-point interconnection and one software global monitoring.",
  },
  api: {
    "title-dot-one": "Using ",
    "title-dot-two": "to help",
    "title-dot-three": "",
    "title-dot-one-first": "perfect API",
    "title-dot-one-second": "unified control",
    "title-dot-one-third": "flexible login",
    "title-dot-two-first": "developers",
    "title-dot-two-second": "enterprises",
    "title-dot-two-third": "customers",
    "title-dot-three-first": "",
    "title-dot-three-second": "",
    "title-dot-three-third": "",
    roi: {
      userRate: "User conversion rate",
      maintenanceCost: "Operational costs",
      developmentTime: "Developer-hours",
      dataFrom: "DATA FROM GARTNER",
    },
    doc: {
      type: "Doc",
      title: "Quick start",
      descript: "Learn how to use Authing and the API provided by Authing",
    },
    community: {
      type: "Community",
      title: "Developer Forum",
      descript: "Communicate with Authing's engineers and other developers",
    },
  },
  product: {
    title: "Authing does more than just login",
    product1: {
      title: "Single Sign-On",
      titleSmall: "SSO",
      subtitle:
        "Single Sign-On (SSO) means that in multiple application systems, users only need to log in once to access all mutually trusted application systems.",
    },
    product2: {
      title: "Authing Sync",
      titleSmall: "Sync",
      subtitle:
        "Help enterprises conveniently synchronize upstream data to downstream applications.",
      // title: "Multi-Factor Authentication",
      // subtitle:
      //   "MFA can add an extra layer of security protection in addition to the user name and password, and perform secure identity verification without sacrificing user experience.",
    },
    product3: {
      title: "Number Verification",
      titleSmall: "Vertification",
      subtitle:
        "Users can complete registration/login with real numbers with one-click authorization, and establish an account system based on mobile phone numbers for developers.",
    },
    product4: {
      title: "Access Gateway",
      titleSmall: "Gateway",
      subtitle:
        "Help old applications expand identity authentication efficiently, and protects the original system from illegal infringements.",
    },
    product5: {
      title: "Authorization Management",
      titleSmall: "Authorization",
      subtitle:
        "Allow enterprises to achieve dynamic, fine-grained authorization and unified authorization management through role- and attribute-based access control.",
    },
    product6: {
      title: "Universal Login(Guard)",
      titleSmall: "Guard",
      subtitle:
        "It is an emendable login form that can be configured according to your needs and easily add various social login methods.",
    },
    product7: {
      title: "Database Connections",
      titleSmall: "Database",
      subtitle:
        'Support enterprises to connect to their own maintained databases, or to securely move data from legacy systems to the cloud through "inert migration".',
    },
    product8: {
      title: "Patner Network",
      titleSmall: "Integration",
      subtitle:
        "Integrated international applications and systems, to help enterprises connect every data efficiently.",
    },
    product9: {
      title: "Multifactor Authentication",
      titleSmall: "MFA",
      subtitle:
        "MFA can add an extra layer of security protection in addition to the user name and password, and perform secure identity verification without sacrificing user experience.",
    },
    product10: {
      title: "Wechat Solution",
      titleSmall: "Wechat Solution",
      subtitle:
        "For Wechat ecology, Authing provides a simple, unified SDK for developers. Developers only need to call the front end SDK without having to worry about the various complex identity logic.",
    },
    product11: {
      title: "IAM Alternative Solution",
      titleSmall: "IAM Alternative Solution",
      subtitle:
        "IDaaS delivers more benefits to enterprises compared to IAM: improved marketing and operational efficiency; accelerated new business go-live; improved security to reduce the risk of cyber attacks; and improved user experience.",
    },
    product12: {
      title: "Multi-Tenant",
      titleSmall: "Multi-Tenant",
      subtitle:
        "Help enterprises quickly build a multi tenant management architecture, without the need to build from scratch, and quickly achieve data and resource permission isolation.",
    },
  },
  solution: {
    title: "Next Generation Full-Scene Identity Cloud",
    tabs: {
      tab1: {
        label: "Industry Solutions",
        desc:
          "Companies like yours are rebuilding their identity management system",
      },
      tab3: {
        label: "Nationalized Replacement",
        desc:
          "The services you use, there are more money and time saving alternatives",
      },
    },
    firstProducts: {
      firstProducts1: {
        title: "Technology/Internet",
        subtitle:
          "Unify the login and authentication system of the applications, so that technological products have a technological sense of identity management.",
      },
      firstProducts2: {
        title: "Manufacturing Industry",
        subtitle:
          "Establish a confidential protection and identity security system as early as possible to support the high growth of products and enterprises.",
      },
      firstProducts3: {
        title: "Financial Services",
        subtitle:
          "Implement private deployment, and unify internally to enhance the financial service experience externally.",
      },
      firstProducts4: {
        title: "Healthcare Industry",
        subtitle:
          "Improve identity management norms, finely manage device permissions, and protect patient privacy and research data.",
      },
      firstProducts5: {
        title: "Retail Industry",
        subtitle:
          "Users need a faster and better online buying experience, and you need to make changes from the first step of login authentication.",
      },
      firstProducts6: {
        title: "Real Estate Industry",
        subtitle:
          "Synchronize heterogeneous data from multiple systems to automate the management of 10,000 employees, owners and tenants.",
      },
      firstProducts7: {
        title: "Game Industry",
        subtitle:
          "Quickly automate your identity management, to make the game addictive from the moment users log in.",
      },
      firstProducts8: {
        title: "Education Industry",
        subtitle:
          "Create a secure, shared and unified campus identity system and online education login service to put knowledge at your fingertips.",
      },
      firstProducts9: {
        title: "Automotive Industry",
        subtitle:
          "Efficiently and securely integrate applications, allowing R&D efforts to focus on a smooth and elegant driving experience.",
      },
      firstProducts10: {
        title: "Public Sector",
        subtitle:
          "Let citizens use one account to securely log in to all government systems and help digital reform.",
      },
      firstProducts11: {
        title: "SaaS Industry",
        subtitle:
          "Companies need to efficiently collaborate with upstream and downstream partners, and you can achieve that with unified authentication and management.",
      },
    },
    thirdProducts: {
      thirdProducts1: {
        title: "Microsoft AD Identity Solution",
        subtitle:
          "Match the high speed of enterprise growth with AD identity enhancement solutions.",
        contentListValue1: "Improve scalability",
        contentListValue2: "Enrich usage scenarios",
        contentListValue3:
          "Enhance the efficiency of information transformation",
      },
      thirdProducts2: {
        title: "Move from Okta",
        subtitle:
          "Authing provides fast and stable identity services to replace Okta.",
        contentListValue1: "Provide identity workflow, directory, etc",
        contentListValue2:
          "Provide application integration, user analysis, development components",
        contentListValue3: "More adaptable to localized applications",
      },
      thirdProducts3: {
        title: "Move from AWS Cognito",
        subtitle: "Use the Authing User Pool to build a bridge to AWS access.",
        contentListValue1: "More secure access to AWS services",
        contentListValue2: "More Effective API Protection",
        contentListValue3: "Access to Cognito for localized applications",
      },
    },
  },
  customer: {
    title: "40,000+ Companies and Developers Choose Authing",
    productLists1: {
      firm: "—— PingCAP",
      content:
        "We use Authing to unify multiple identity sources to achieve flexible and efficient SSO.",
    },
    productLists2: {
      firm: "—— BOSCH",
      content:
        "Authing has low infrastructure requirements, enabling significant savings in deployment.",
    },
    productLists3: {
      title: "Haidilao",
      firm: "—— Haidilao",
      content:
        "Authing help us connect 200+ Apps to achieve granular permission managemen.",
    },
    productLists4: {
      firm: "—— Bentley",
      content:
        "Authing provides a seamless auth experience for our internal & external users.",
    },
    productLists5: {
      firm: "—— CSDN",
      content:
        "Authing's API and SDK allow us to shorten the development cycle by 1 month.",
    },
  },
  multiply: {
    title: "A safe future, Connect now",
    "button-text": "Check now",
    catalogue1: {
      title: "Safety First",
      subtitle: "ISO&GDPR safety certifications, etc.",
      text: "Certificates and Awards",
      subtext:
        "Awarded several safety certificates and be selected as an innovative company",
      compliance1: "zero-trust-compliance1-en.png",
      compliance2: "zero-trust-compliance2-en.png",
      compliance3: "zero-trust-compliance3-en.png",
      compliance4: "zero-trust-compliance4-en.png",
      compliance5: "zero-trust-compliance5-en.png",
      compliance6: "zero-trust-compliance6-en.png",
      compliance7: "zero-trust-compliance7-en.png",
      contentLists1: {
        title: "ISO",
        desc: "winning ISO management certificate",
      },
      contentLists2: {
        title: "Protection",
        desc: "winning information protection certificate",
      },
      contentLists3: {
        title: "Innovation",
        desc: "Be selected as a high-tech enterprise by ministry of technology",
      },
      contentLists4: {
        title: "Security",
        desc:
          "Be selected in “white paper on China’s network security industry”",
      },
      contentLists5: {
        title: "GDPR",
        desc: 'Adoption of the EU "GDPR" General Data Protection Regulation',
      },
    },
    catalogue2: {
      title: "Join the W3C",
      subtitle:
        "Join W3C and participate in the development of international standards",
      text: "Authing joined the W3C",
      subtext:
        "Authing officially joined the W3C organization, will participate in the development of international standards.",
    },
    catalogue3: {
      title: "CNCF landscape",
      subtitle: "The only cloud-native IDaaS in China to be selected",
      text: "Authing was selected for CNCF landscape",
      subtext:
        "Authing, as the only cloud-native project in China, is featured in the key management of CNCF Landscape",
    },
    catalogue4: {
      title: "Named to Forbes Asia",
      subtitle: 'Forbes Asia "Most Wanted Companies"',
      text: "Named to Forbes Asia",
      subtext:
        'Authing was named to Forbes Asia\'s "100 to Watch Companies" list.',
    },
  },
};
